export function startBtnSpin(btnElem: HTMLElement): void {
  btnElem.classList.add("throbber");
  btnElem.classList.add("spin");
}
